import { createLucideIcon } from "lucide-react";

export const Sun = createLucideIcon(
    "Sun",
    [
        [
            "path",
            {
                d: "M12 20.5V22",
                key: "14e100",
            },
        ],
        [
            "path",
            {
                d: "M12 2V3.5",
                key: "1seubi",
            },
        ],
        [
            "path",
            {
                d: "M17 12C17 14.7614 14.7614 17 12 17C9.23858 17 7 14.7614 7 12C7 9.23858 9.23858 7 12 7C14.7614 7 17 9.23858 17 12Z",
                key: "13sa61",
            },
        ],
        [
            "path",
            {
                d: "M19.0708 19.0713L18.0101 18.0106",
                key: "opldue",
            },
        ],
        [
            "path",
            {
                d: "M19.0713 4.9287L18.0106 5.9894",
                key: "1mz7g5",
            },
        ],
        [
            "path",
            {
                d: "M22 12H20.5",
                key: "xgnudh",
            },
        ],
        [
            "path",
            {
                d: "M3.5 12H2",
                key: "mhfb3a",
            },
        ],
        [
            "path",
            {
                d: "M5.9893 5.9893L4.9286 4.9286",
                key: "16d6qe",
            },
        ],
        [
            "path",
            {
                d: "M5.9898 18.0107L4.9291 19.0714",
                key: "8i6foc",
            },
        ],
    ],
);
